import React from "react";

const Homesection3Button = (props) => {
  return (
    <button
      className="cursor-pointer rounded-lg mx-1 my-4 hover:bg-blue-700  border border-x-blue-900 border-y-blue-900 px-2 py-2 font-mono "
      onClick={() => {
        props.func(props.name);
      }}
    >
      {props.name}
    </button>
  );
};

export default Homesection3Button;
